// Swiper modules
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const initSanctumsSlider = () => {
    const section = document.querySelector('.js-sanctums-slider');
    if (!section) return;

    const sliderContainer = section.querySelector('.swiper');
    const wrapper = section.querySelector('.swiper-wrapper');
    let swiperInstance = null;
    let resizeTimer = null;

    const doInit = () => {
        const isMobile = window.innerWidth <= 992;

        if (isMobile && !swiperInstance) {
            swiperInstance = new Swiper(sliderContainer, {
                modules: [Navigation],
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 20,
                grabCursor: true,
                watchOverflow: true,
                speed: 800,
                navigation: {
                    nextEl: ".js-sanctums-next",
                    prevEl: ".js-sanctums-prev",
                },
            });
        } else if (!isMobile && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;

            if (wrapper) {
                wrapper.style.transform = '';
                wrapper.style.width = '';
            }
        }
    };

    // Debounced resize handler
    const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(doInit, 250);
    };

    // Use IntersectionObserver to delay init until visible
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                doInit();
                window.addEventListener('resize', handleResize);
                observer.unobserve(section);
            }
        });
    }, { rootMargin: '100px' });

    observer.observe(section);
};

document.addEventListener('DOMContentLoaded', initSanctumsSlider);

export default initSanctumsSlider;

